/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const MESSAGE_BAR_AUTO_DISMISS_ANIMATION_TIME_V1_MS = 0;
export const MESSAGE_BAR_AUTO_DISMISS_DELAY_V1_MS = 5000;